exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".onboard-interest__item[data-v-73e52a04]{border-radius:10px}.ctt-card__cont[data-v-73e52a04]{min-height:270px}@media screen and (max-width:767.97px){.ctt-card__cont[data-v-73e52a04]{min-height:150px}.onboard-interest[data-v-73e52a04]{margin-top:25px;padding:0 10px}.onboard-interest__action[data-v-73e52a04]{margin-top:25px;font-size:14px}.onboard-interest__item.active~.onboard-interest__item[data-v-73e52a04]{padding:0 10px}}", ""]);

// exports
